import { yupResolver } from '@hookform/resolvers/yup';
import { useMutation } from '@tanstack/react-query';
import { useNotifications } from '@toolpad/core';
import { useForm } from 'react-hook-form';
import { FormContainer, TextFieldElement } from 'react-hook-form-mui';
import { Card, CardContent, CardHeader, Stack } from '@mui/material';

import { EditButtons } from '@barboxx/admin-components';
import { ALCOHOL_CATEGORY_SCHEMA } from '@barboxx/admin-utils';
import Api from '@barboxx/api';
import { ProductCategory } from '@barboxx/models';
import { Can, useBool } from '@barboxx/react-utils';

interface Props {
    productCategory: ProductCategory;
}

export const ProductCategoryDetailsCard = ({ productCategory }: Props) => {
    const [editable, editableActions] = useBool(false);
    const notifications = useNotifications();
    const { types, ...rest } = productCategory;

    const formContext = useForm<ProductCategory.UpdateRequest>({
        resolver: yupResolver(ALCOHOL_CATEGORY_SCHEMA),
        defaultValues: rest,
    });

    const mutateUser = useMutation({
        mutationKey: ['productCategory', productCategory.id],
        mutationFn: (data: ProductCategory.UpdateRequest) =>
            Api.Products.Categories.putProductCategory(
                productCategory.id,
                data
            ),
    });

    const handleCancel = () => {
        editableActions.off();
        formContext.reset(undefined);
    };

    const onSubmit = async (values: ProductCategory) => {
        return mutateUser
            .mutateAsync(values)
            .then(({ data }) => {
                notifications.show('Updated product category!', {
                    severity: 'success',
                });

                editableActions.off();
                formContext.reset(data);
            })
            .catch(e => {
                notifications.show('Error Updating product category!', {
                    severity: 'error',
                });
            });
    };

    return (
        <Card>
            <CardHeader title="Alcohol Category Details" />
            <CardContent>
                <FormContainer onSuccess={onSubmit} formContext={formContext}>
                    <Stack gap={2}>
                        <TextFieldElement
                            fullWidth
                            name="name"
                            disabled={!editable}
                            label="Name"
                        />
                        <TextFieldElement
                            fullWidth
                            name="description"
                            disabled={!editable}
                            label="Description"
                        />
                        <Can I="update" a="Alcohol">
                            <EditButtons
                                formContext={formContext}
                                handleCancel={handleCancel}
                                editable={editable}
                                editableActions={editableActions}
                            />
                        </Can>
                    </Stack>
                </FormContainer>
            </CardContent>
            {/* <CardActions
                sx={{
                    paddingBottom: 2,
                    paddingX: 3,
                    justifyContent: 'end',
                }}
            ></CardActions> */}
        </Card>
    );
};
